import * as React from "react";
import { Reason, ReasonType } from "../types/reason";
import { useGetReasonsByTypeQuery } from "../services/reason.service";
import SelectData from "./global/SelectData";

const SelectReason = ({
  onChange,
  sx,
  label = "Reason",
  error,
  helperText,
  type,
  value,
}: {
  onChange: (arg?: string) => void;
  sx?: any;
  label?: string;
  error?: boolean;
  helperText?: React.ReactNode;
  type: ReasonType;
  value?: string;
}) => {
  const {
    data: reasons,
    isLoading,
    isFetching,
  } = useGetReasonsByTypeQuery(type);

  return (
    <SelectData
      data={reasons}
      getOptionLabel={(reason) => reason.name}
      getOptionValue={(reason) => reason.name}
      value={value}
      onChange={(value) => onChange(value as string)}
      label={label}
      placeholder="Search reason..."
      error={error}
      helperText={helperText}
      isLoading={isLoading}
      isFetching={isFetching}
      sx={sx}
    />
  );
};
export default SelectReason;
